module.exports = __webpack_public_path__ + "media/images/icons/material/trash-369288703fff1d7a1b2dc819ef152e8c.svg";